/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { BookClosedIcon16Light } from './BookClosedIcon16Light';
import { BookClosedIcon16Regular } from './BookClosedIcon16Regular';
import { BookClosedIcon16Solid } from './BookClosedIcon16Solid';
import { BookClosedIcon20Light } from './BookClosedIcon20Light';
import { BookClosedIcon20Regular } from './BookClosedIcon20Regular';
import { BookClosedIcon20Solid } from './BookClosedIcon20Solid';
import { BookClosedIcon24Regular } from './BookClosedIcon24Regular';
import { BookClosedIcon24Solid } from './BookClosedIcon24Solid';
import { BookClosedIcon32Regular } from './BookClosedIcon32Regular';
import { BookClosedIcon64Regular } from './BookClosedIcon64Regular';
var sizes = {
    16: {
        light: BookClosedIcon16Light,
        regular: BookClosedIcon16Regular,
        solid: BookClosedIcon16Solid,
    },
    20: {
        light: BookClosedIcon20Light,
        regular: BookClosedIcon20Regular,
        solid: BookClosedIcon20Solid,
    },
    24: {
        regular: BookClosedIcon24Regular,
        solid: BookClosedIcon24Solid,
    },
    32: {
        regular: BookClosedIcon32Regular,
    },
    64: {
        regular: BookClosedIcon64Regular,
    },
};
export var BookClosedIcon = forwardRef('BookClosedIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
